import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/sanphamService';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";

import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import {ClipLoader} from "react-spinners";
//import Editor from '@app/pages/FUtil/Editor';
import Editor from '@app/pages/FUtil/Editor';
import CountriesListComponent from "@pages/FUtil/CountriesListComponent";
import CityListComponent from "@pages/FUtil/CityListComponent";
import DistrictListComponent from "@pages/FUtil/DistrictListComponent";
import WardsListComponent from "@pages/FUtil/WardsListComponent";
import DaohuuAutocompleteComponent from "@pages/FUtil/DaohuuAutocompleteComponent";
import NhaphanphoiListComponent from "@pages/FUtil/NhaphanphoiListComponent";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import LoaiphuchinhListComponent from "@pages/FUtil/LoaiphuchinhListComponent";
import DonvitinhListComponent from "@pages/FUtil/DonvitinhListComponent";
function SanphamEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);
  
    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initial = {
        id: id || 0,
        ten : '',
        ma : '',
        Editor1 :'',
        Editor2 :'',
        loaiphuchinh_fk : null,
        is_rang: false,
        donvitinh_fk : null,
        trangthai_fk : 1,
        ghi_chu: ''
    };

    const [obj, setObj] = useState({...initial});
    const onChangeInput =  (e) => {
        const {name, value, checked, type} = e.target;

        if(type ==='checkbox') {

            setObj((prevState) => ({
                ...prevState,
                [name]: checked
            }));

        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };
   
    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)    
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;

                setObj(userX);

            });
        }

    };

    useEffect(async () => {
       
         await checkRole({
                    pathname: location.pathname,
                    isAddMode,
                    currController,
                    history
                });

        await createRs();

    }, []);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if(!data.ma || data.ma.length === 0)
        {
            alert('Vui lòng nhập mã');
            return;
        }

        if(!data.ten || data.ten.length === 0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
         isAddMode ?  createUser(data) : update(data);

    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createUser(data) {
        setLoading(true);
        // delete data.ma;
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            
            history.push('/'+currController);

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }
    async function update(data) {
        setLoading(true);
      
        const result = await myService.Update(id,data);
        if (result.status ==="1") {
            alertService.success(result.msg);
          
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
            className="btn  btn-success  mr-1"
            
            icon="right fas fa-angle-left"
        onClick={saveClick}
         >
        <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
         </Button>   
        );

    }

    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i></Button>
                  {htmlButtonSave}
                </div>
                <div className="form-row p-2">
                </div>
                <div className="tab-pane fade show active" label="Thông tin bán hàng" id="thongtinnhanvien">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <LoaiphuchinhListComponent
                                    loaiphuchinh_fk = {obj.loaiphuchinh_fk} onChange ={(opt, e) => {
                                    const target = {name: "loaiphuchinh_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <DonvitinhListComponent
                                    donvitinh_fk = {obj.donvitinh_fk} onChange ={(opt, e) => {
                                    const target = {name: "donvitinh_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Mã</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    name="ma"
                                    id ="ma"
                                    value={obj.ma}
                                    onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Tên</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    name="ten"
                                    id ="ten"
                                    value={obj.ten}
                                    onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <label>Ghi chú</label>
                                <textarea rows="2" maxLength="500" className="form-control" name="ghi_chu" id="ghi_chu" value={obj.ghi_chu} onChange={onChangeInput} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk}
                                    /*onChange ={(e) => onSelectedChangeFilter('trangthai_fk', e)}*/
                                                        onChange ={(opt, e) => {
                                                            const target = {name: "trangthai_fk", value: opt?.value};
                                                            onChangeInput({target})}}
                                                        filterIds = { [0,1] }
                                                        trangthaiName = "name"
                                />

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <label>Sản phẩm là răng</label>
                                <br/>
                                <input type="checkbox" name='is_rang'
                                       value={obj.is_rang}
                                       checked={obj.is_rang}
                                       onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
}

export {SanphamEdit};
